import { combineReducers } from 'redux';

const giftMasterInitialState = {
  loadStatus: 0,
  didLoadAll: false,
  query: {
    tab: 'unused',
    size: 20,
  },
  list: null,
};

const storeMasterInitialState = {
  loadStatus: 0,
  didLoadAll: false,
  query: {
    tab: 'unused',
    size: 20,
  },
  list: null,
};

const cashMasterInitialState = {
  loadStatus: 0,
  didLoadAll: false,
  query: {
    tab: 'unused',
    size: 20,
  },
  list: null,
};

const postageMasterInitialState = {
  loadStatus: 0,
  didLoadAll: false,
  query: {
    tab: 'unused',
    size: 20,
  },
  list: null,
};

const giftDetailsInitialState = {
  loadStatus: 0,
};

const giftPickerInitialState = {
  loadStatus: 0,
  didLoadAll: false,
  list: null,
  query: {
    size: 20,
  },
};

const receivedInitialState = {
  loadStatus: 0,
  list: null,
  defindList: null,
};

const newuserInitialState = {
  loadStatus: 0,
  list: null,
};

const batchMasterInitialState = {
  loadStatus: 0,
  didLoadAll: false,
  query: { type: '', oprate: '', keyword: '', size: 20 },
  list: null,
};

const batchDonateMasterInitialState = {
  loadStatus: 0,
  query: { couponIds: [] },
  list: null,
};

const batchOperateInitialState = {
  saveStatus: 0,
};

function couponsReducer(state = {}, action) {
  switch (action.type) {
    case 'LOAD_COUPON_COMPLETION': {
      const { code, data, error } = action;

      if (error) {
        return state;
      }

      return {
        ...state,
        [code]: data,
      };
    }

    case 'LOAD_GIFT_LIST_COMPLETION':
    case 'LOAD_CASH_LIST_COMPLETION':
    case 'LOAD_STORE_LIST_COMPLETION':
    case 'LOAD_POSTAGE_LIST_COMPLETION':
    case 'LOAD_PICKER_GIFT_LIST_COMPLETION':
    case 'LOAD_RECEIVED_COUPON_LIST_COMPLETION':
    case 'LOAD_NEWUSER_COUPON_LIST_COMPLETION':
    case 'LOAD_COUPON_BATCH_LIST_COMPLETION':
    case 'LOAD_COUPON_BATCH_DONATE_LIST_COMPLETION':
    case 'BATCH_DONATE_COUPON_COMPLETION':
    case 'BATCH_GET_COUPON_COMPLETION':
    case 'BATCH_CANCEL_DONATE_COUPON_COMPLETION': {
      if (action.error) {
        return state;
      }

      const coupons = action.list.reduce(
        (obj, coupon) => {
          const code = coupon.code;

          if (code) {
            obj[code] = { ...obj[code], ...coupon };
          }
          return obj;
        },
        { ...state }
      );

      return coupons;
    }

    case 'PRE_CREATE_HAPPYGO_ORDER_COMPLETION':
    case 'PRE_CREATE_ORDER_COMPLETION':
    case 'LOAD_CART_EXTRA_INFO_COMPLETION': {
      if (action.error) {
        return state;
      }
      const {
        cashCouponList,
        postageCouponList,
        expectedCashCouponList,
      } = action.data.coupon;
      let list = [];

      if (cashCouponList) {
        list = list.concat(cashCouponList);
      }

      if (postageCouponList) {
        list = list.concat(postageCouponList);
      }
      if (expectedCashCouponList) {
        list = list.concat(expectedCashCouponList);
      }

      return {
        ...state,
        ...list.reduce((obj, coupon) => {
          const code = coupon.code;

          if (code) {
            obj[code] = coupon;
          }
          return obj;
        }, {}),
      };
    }

    default:
      return state;
  }
}

function actionsReducer(state = {}, action) {
  switch (action.type) {
    case 'BATCH_GET_COUPON':
    case 'BATCH_DONATE_COUPON':
    case 'BATCH_CANCEL_DONATE_COUPON': {
      const { list } = action;
      return {
        ...state,
        ...(list || []).reduce((obj, coupon) => {
          obj[coupon.code] = true;
          return obj;
        }, {}),
      };
    }

    case 'BATCH_GET_COUPON_COMPLETION':
    case 'BATCH_DONATE_COUPON_COMPLETION':
    case 'BATCH_CANCEL_DONATE_COUPON_COMPLETION': {
      const { list } = action;
      let newState = { ...state };
      for (let i = 0; i < list.length; i++) {
        const coupon = list[i];
        delete newState[coupon.code];
      }
      return newState;
    }

    default:
      return state;
  }
}

function giftMasterReducer(state = giftMasterInitialState, action) {
  switch (action.type) {
    case 'LOAD_GIFT_LIST': {
      if (!action.willReload) {
        return {
          ...state,
          loadStatus: 1,
        };
      }

      return {
        ...state,
        loadStatus: 1,
        query: {
          ...state.query,
          ...action.query,
        },
        list: null,
      };
    }

    case 'LOAD_GIFT_LIST_COMPLETION': {
      const { error, willReload } = action;

      if (error) {
        return {
          ...state,
          loadStatus: 0,
          list: willReload ? null : state.list,
        };
      }

      const list = (action.list || []).map(gift => gift.code);

      return {
        ...state,
        loadStatus: 2,
        didLoadAll: list.length < state.query.size,
        list: willReload ? list : (state.list || []).concat(list),
      };
    }

    default:
      return state;
  }
}

function cashMasterReducer(state = cashMasterInitialState, action) {
  switch (action.type) {
    case 'LOAD_CASH_LIST': {
      if (!action.willReload) {
        return {
          ...state,
          loadStatus: 1,
        };
      }

      return {
        ...state,
        loadStatus: 1,
        query: {
          ...state.query,
          ...action.query,
        },
        list: null,
      };
    }

    case 'LOAD_CASH_LIST_COMPLETION': {
      const { error, willReload } = action;

      if (error) {
        return {
          ...state,
          loadStatus: 0,
          list: willReload ? null : state.list,
        };
      }

      const list = (action.list || []).map(cash => cash.code);

      return {
        ...state,
        loadStatus: 2,
        didLoadAll: list.length < state.query.size,
        list: willReload ? list : (state.list || []).concat(list),
      };
    }

    default:
      return state;
  }
}

function storeMasterReducer(state = storeMasterInitialState, action) {
  switch (action.type) {
    case 'LOAD_STORE_LIST': {
      if (!action.willReload) {
        return {
          ...state,
          loadStatus: 1,
        };
      }

      return {
        ...state,
        loadStatus: 1,
        query: {
          ...state.query,
          ...action.query,
        },
        list: null,
      };
    }

    case 'LOAD_STORE_LIST_COMPLETION': {
      const { error, willReload } = action;

      if (error) {
        return {
          ...state,
          loadStatus: 0,
          list: willReload ? null : state.list,
        };
      }

      const list = action.list;

      return {
        ...state,
        loadStatus: 2,
        didLoadAll: list.length < state.query.size,
        list: willReload ? list : (state.list || []).concat(list),
      };
    }

    default:
      return state;
  }
}

function postageMasterReducer(state = postageMasterInitialState, action) {
  switch (action.type) {
    case 'LOAD_POSTAGE_LIST': {
      if (!action.willReload) {
        return {
          ...state,
          loadStatus: 1,
        };
      }

      return {
        ...state,
        loadStatus: 1,
        query: {
          ...state.query,
          ...action.query,
        },
        list: null,
      };
    }

    case 'LOAD_POSTAGE_LIST_COMPLETION': {
      const { error, willReload } = action;

      if (error) {
        return {
          ...state,
          loadStatus: 0,
          list: willReload ? null : state.list,
        };
      }

      const list = (action.list || []).map(postage => postage.code);

      return {
        ...state,
        loadStatus: 2,
        didLoadAll: list.length < state.query.size,
        list: willReload ? list : (state.list || []).concat(list),
      };
    }

    default:
      return state;
  }
}

function giftDetailsReducer(state = {}, action) {
  switch (action.type) {
    case 'LOAD_GIFT_DETAIL': {
      return {
        ...state,
        [action.giftId]: {
          ...(state[action.giftId] || giftDetailsInitialState),
          loadStatus: 1,
        },
      };
    }

    case 'LOAD_GIFT_DETAIL_COMPLETION': {
      return {
        ...state,
        [action.giftId]: {
          ...(state[action.giftId] || giftDetailsInitialState),
          loadStatus: action.error ? 0 : 2,
        },
      };
    }

    default:
      return state;
  }
}

function giftPickerReducer(state = giftPickerInitialState, action) {
  switch (action.type) {
    case 'LOAD_PICKER_GIFT_LIST': {
      if (!action.willReload) {
        return {
          ...state,
          loadStatus: 1,
        };
      }

      return {
        ...state,
        loadStatus: 1,
        query: {
          ...state.query,
          ...action.query,
        },
        list: null,
      };
    }

    case 'LOAD_PICKER_GIFT_LIST_COMPLETION': {
      const { error, willReload } = action;

      if (error) {
        return {
          ...state,
          loadStatus: 0,
          list: willReload ? null : state.list,
        };
      }

      const list = (action.list || []).map(gift => gift.code);

      return {
        ...state,
        loadStatus: 2,
        didLoadAll: list.length < state.query.size,
        list: willReload ? list : (state.list || []).concat(list),
      };
    }

    default:
      return state;
  }
}

function receivedReducer(state = receivedInitialState, action) {
  switch (action.type) {
    case 'LOAD_RECEIVED_COUPON_LIST': {
      return {
        ...state,
        loadStatus: 1,
      };
    }

    case 'LOAD_RECEIVED_COUPON_LIST_COMPLETION': {
      const { error, list, defindList } = action;

      if (error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      return {
        ...state,
        loadStatus: 2,
        list: list.map(coupon => coupon.code),
        defindList,
      };
    }

    default:
      return state;
  }
}

function newuserReducer(state = newuserInitialState, action) {
  switch (action.type) {
    case 'LOAD_NEWUSER_COUPON_LIST': {
      return {
        ...state,
        loadStatus: 1,
      };
    }

    case 'LOAD_NEWUSER_COUPON_LIST_COMPLETION': {
      const { error, list } = action;

      if (error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      return {
        ...state,
        loadStatus: 2,
        list: list.map(coupon => coupon.code),
      };
    }

    default:
      return state;
  }
}

function pkgsReducer(state = {}, action) {
  switch (action.type) {
    case 'LOAD_COUPON_PKG_COMPLETION':
    case 'LOAD_REG_COUPON_PKG_COMPLETION': {
      const { error, pkgId, data } = action;

      if (error) {
        return state;
      }

      return {
        ...state,
        [pkgId]: data,
      };
    }

    case 'TAKE_COUPON_PKG_COMPLETION':
    case 'TAKE_REG_COUPON_PKG_COMPLETION': {
      const { error, pkgId, data } = action;

      if (error) {
        return state;
      }

      return {
        ...state,
        [pkgId]: {
          ...state[pkgId],
          ...data,
        },
      };
    }

    default:
      return state;
  }
}

function pkgActionsReducer(state = {}, action) {
  switch (action.type) {
    case 'TAKE_COUPON_PKG':
    case 'TAKE_REG_COUPON_PKG': {
      const { pkgId } = action;

      return {
        ...state,
        [pkgId]: {
          ...state[pkgId],
          takeStatus: 1,
        },
      };
    }

    case 'TAKE_COUPON_PKG_COMPLETION':
    case 'TAKE_REG_COUPON_PKG_COMPLETION': {
      const { error, pkgId } = action;

      return {
        ...state,
        [pkgId]: {
          ...state[pkgId],
          takeStatus: error ? 0 : 2,
        },
      };
    }

    default:
      return state;
  }
}

function batchMasterReducer(state = batchMasterInitialState, action) {
  switch (action.type) {
    case 'LOAD_COUPON_BATCH_LIST': {
      if (!action.willReload) {
        return {
          ...state,
          loadStatus: 1,
        };
      }

      return {
        ...state,
        loadStatus: 1,
        query: {
          ...state.query,
          ...action.query,
        },
        list: null,
      };
    }

    case 'LOAD_COUPON_BATCH_LIST_COMPLETION': {
      const { error, willReload } = action;

      if (error) {
        return {
          ...state,
          loadStatus: 0,
          list: willReload ? null : state.list,
        };
      }

      const list = (action.list || []).map(coupon => coupon.code);

      return {
        ...state,
        loadStatus: 2,
        didLoadAll: list.length < state.query.size,
        list: willReload ? list : (state.list || []).concat(list),
      };
    }

    default:
      return state;
  }
}

function batchDonateMasterReducer(
  state = batchDonateMasterInitialState,
  action
) {
  switch (action.type) {
    case 'LOAD_COUPON_BATCH_DONATE_LIST': {
      return {
        ...state,
        loadStatus: 1,
        query: {
          ...state.query,
          ...action.query,
        },
        list: null,
      };
    }

    case 'LOAD_COUPON_BATCH_DONATE_LIST_COMPLETION': {
      const { error } = action;

      if (error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      const list = (action.list || []).map(coupon => coupon.code);

      return {
        ...state,
        loadStatus: 2,
        list,
      };
    }

    default:
      return state;
  }
}

function batchOperateReducer(state = batchOperateInitialState, action) {
  switch (action.type) {
    case 'BATCH_GET_COUPON':
    case 'BATCH_DONATE_COUPON':
    case 'BATCH_CANCEL_DONATE_COUPON': {
      return {
        ...state,
        saveStatus: 1,
      };
    }

    case 'BATCH_GET_COUPON_COMPLETION':
    case 'BATCH_DONATE_COUPON_COMPLETION':
    case 'BATCH_CANCEL_DONATE_COUPON_COMPLETION': {
      return {
        ...state,
        saveStatus: action.error ? 0 : 2,
      };
    }

    default:
      return state;
  }
}

export default combineReducers({
  giftMaster: giftMasterReducer,
  storeMaster: storeMasterReducer,
  cashMaster: cashMasterReducer,
  postageMaster: postageMasterReducer,
  giftDetails: giftDetailsReducer,
  coupons: couponsReducer,
  actions: actionsReducer,
  giftPicker: giftPickerReducer,
  received: receivedReducer,
  newuser: newuserReducer,
  pkgs: pkgsReducer,
  pkgActions: pkgActionsReducer,
  batchMaster: batchMasterReducer,
  batchDonateMaster: batchDonateMasterReducer,
  batchOperate: batchOperateReducer,
});
